/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const createJingleCollectionItemModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор связки"),
"number": z.number().int().describe("Порядковый номер")
    })